import { BenefitHeroSlide } from 'src/models/BenefitHeroSlide/BenefitHeroSlide';
import {
  Banner,
  Copy,
  Heading,
  Subheading,
  Wrapper,
} from './styles';

const BenefitsHero: React.FC<{
  hero?: BenefitHeroSlide | null;
}> = ({ hero }) => {
  if (!hero) {
    return null;
  }

  return (
    <Wrapper>
      <Banner>
        {hero.heading && <Heading>{hero.heading}</Heading>}
        {hero.subheading && <Subheading>{hero.subheading}</Subheading>}
        {hero.copy && <Copy>{hero.copy}</Copy>}
      </Banner>
    </Wrapper>
  );
};

export default BenefitsHero;
